import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/nominas/nombramientos/';

/**
 * GET Plazas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getNombramientos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};
/**
 * GET Plazas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getNombramientosSinPaginar = async (params) => {
  try {
    const response = await API.get('/nominas/nombramientos-sin-paginado/', { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};
/**
 * GET Plazas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getNombramientosvistaoptimized = async (params) => {
  try {
    const response = await API.get('/nominas/nombramientos-vista-optimized', { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};
/**
 * GET Plaza
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getNombramiento = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Plaza
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postNombramiento = async (values) => {
  try {
    // eslint-disable-next-line no-param-reassign
    values.clave = '1';
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Plaza
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchNombramiento = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Nombramiento — documento de evidencia de firma (PDF)
 * Sube/reemplaza `documento_firmado_evidencia` vía multipart/form-data.
 * Cada reemplazo queda registrado en NombramientoDocumentoHistorial (backend).
 * @param {number} id
 * @param {File} file
 * @returns {Promise<object|boolean>}
 */
export const patchNombramientoDocumentoEvidencia = async (id, file) => {
  try {
    const formData = new FormData();
    formData.append('documento_firmado_evidencia', file);
    const response = await API.patch(`${baseURI}${id}/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    onSuccess(response, 'Evidencia de firma cargada correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Plaza
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteNombramiento = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PUT Nombramiento
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const putNombramiento = async (id, values) => {
  try {
    const response = await API.put(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PUT Dar Visto Bueno Masivo
 * Mueve nombramientos de Pendientes de Firma → Vigentes (sin FEA).
 * @param {number[]} ids - IDs de los nombramientos
 * @returns {Promise<boolean>}
 */
export const postDarVistoBuenoMasivo = async (ids) => {
  try {
    const response = await API.put('/nominas/dar-visto-bueno-masivo/', ids.map((id) => ({ id })));
    onSuccess(response, 'Visto bueno aplicado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const getEstadosDeNombramientos = async () => {
  try {
    const response = await API.get('/catalogos/estados-de-nombramientos/');
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};
